import * as React from "react";
const SvgClockout = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 1L9 9L1 9", stroke: "#ED6C02", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgClockout;
